<template>
	<div class="explain" id="myAccout" :style="{'margin-right':isdetailopen?'700px':'0px','width': isdetailopen?'calc(100% - 700px)':''}">
	  <div class="rightWap">
	    <div class="myAccount">
	      <h1>我的账户<img src="/images/rightClose.png" @click="closeFloat" class="closePop"/></h1>
	      <ul class="accountTj">
	        <li><img src="/images/user.png"/></li>
	        <li>
	          <em>阅读（次）</em>
	          <span>{{yuedu}}</span>
	        </li>
	        <li>
	          <em>订阅（个）</em>
	          <span>{{dingyue}}</span>
	        </li>
	        <li>
	          <em>收藏（个）</em>
	          <span>{{shoucang}}</span>
	        </li>
	      </ul>
	      <dl class="information">
					<dt>用户名</dt>
					<dd>
					  <div v-if="!isChangeUsername" class="item" id="a">
							<span>{{completeUserinfo.username}}</span>
							<img v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'" @click="isChangeUsername=true" src="/images/edit.png" class="edit"/>
						</div>
						<ul v-else id="editUser">
						  <li><input type="text" v-model="newUsername" placeholder="请输入新的用户名"/></li>
						  <li><input type="button" @click="isChangeUsername=false" value="取消" class="cancel"/>
							<input type="button" @click="changeUsername" value="确认" class="sub"/></li>
						</ul>
					</dd>
					<template v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'">
						<dt>绑定手机号</dt>
						<dd>
						  <div v-if="!isChangePhone" class="item" id="b">
								<span>{{completeUserinfo.tel}}</span>
								<img v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'" @click="isChangePhone=true" src="/images/edit.png" class="edit"/>
							</div>
						  <ul v-else id="editPhone">
						    <li><input type="text" v-model="completeUserinfo.tel" disabled></li>
						    <li><input type="text" v-model="oldphonecode" placeholder="旧手机号验证码"><input @click="sendOldPhoneCode" :disabled="oldphonecountdown>0" type="button" :value="oldphonecountdown?oldphonecountdown:'获取验证码'" class="send"></li>
						    <li><input type="text" v-model="newPhone" placeholder="请输入新的手机号"></li>
						    <li><input type="text" v-model="newphonecode" placeholder="新手机号验证码"><input @click="sendNewPhoneCode" :disabled="newphonecountdown>0" type="button" :value="newphonecountdown?newphonecountdown:'获取验证码'" class="send"></li>
						    <li><input type="button" @click="isChangePhone=false" value="取消" class="cancel"/><input type="button" @click="changePhone" value="确认" class="sub"/></li>
						  </ul>
						</dd>
					</template>
	        <template v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'">
						<dt>密码</dt>
						<dd>
						  <div v-if="!isChangePassword" class="item" id="c">
								<span>已设置</span>
								<img v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'" @click="isChangePassword=true" src="/images/edit.png" class="edit"/>
							</div>
						  <ul v-else id="editPassWord">
						    <li><input type="password" placeholder="新密码" v-model="newPassword" @blur="checkPasswordError"></li>
								<li style="color: #bd1a2d;" v-show="pisweekalert">{{pisweekalert}}</li>
						    <li style="color: #A1A4AB; padding:0 24px">6~20个字符，可以包含字母、数字以及标点符号（除空格），建议字母、数字以及标点符号至少包含2种</li>
						    <li><input type="password" placeholder="确认新密码" v-model="newPasswordConfirm"></li>
						    <li><input type="text" placeholder="请输入验证码" v-model="pwdcode"><input type="button" :value="pwdcountdown?pwdcountdown:'获取验证码'" class="send" @click="sendPWDCode" :disabled="pwdcountdown>0"></li>
						    <li><input type="button" value="取消" class="cancel" @click="isChangePassword=false"/><input type="button" value="确认" class="sub" @click="changePassword"/></li>
						  </ul>
						</dd>
					</template>
	        
	        <dt>已绑定集团</dt>
	        <dd>
						<!-- <div class="item"> -->
							<span v-if="completeUserinfo.vipGroupID&&completeUserinfo.vipGroupName">{{completeUserinfo.vipGroupName}}</span>
							<span v-else-if="completeUserinfo.vipGroupID&&!completeUserinfo.vipGroupName">{{completeUserinfo.company}}</span>
							<span v-else>{{completeUserinfo.vipGroupName}}</span>
							<!-- <img v-if="completeUserinfo.usertype=='1'&&completeUserinfo.vipGroupID==''" @click="showbangding()" src="/images/edit.png" class="edit"/>
							<img v-else-if="completeUserinfo.usertype=='2'" @click="showquxiao()" src="/images/edit.png" class="edit"/>
							<img v-if="completeUserinfo.usertype=='2'" @click="showyanqi()" src="/images/edit.png" class="edit"/> -->
						<!-- </div> -->
						<ul >
						  <li>
								<!-- <input type="button" @click="showbangding()" value="去认证" class="sub"/> -->
								<input type="button" v-if="completeUserinfo.usertype=='1'&&completeUserinfo.vipGroupID==''" @click="showbangding()" value="去认证" class="sub"/>
								<input type="button" v-else-if="completeUserinfo.usertype=='2'" @click="showquxiao()" value="取消认证" class="sub"/>
								<input type="button" v-if="completeUserinfo.usertype=='2'" @click="showyanqi()" value="延期" class="sub"/>
							</li>
						</ul>
					</dd>
					<template v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'||completeUserinfo.usertype=='3'">
						<dt>账号有效期</dt>
						<dd style="margin-bottom: 0"><span>{{(completeUserinfo.beginTime?completeUserinfo.beginTime.substring(0,10):'')+' ~ '+(completeUserinfo.endTime?completeUserinfo.endTime.substring(0,10):'')}}</span></dd>
					</template>
	        
	      </dl>
	    </div>
	  </div>
	</div>
</template>

<script>
	import md5 from 'js-md5';
	export default {
		data() {
			return {
				loadingMask:false,
				completeUserinfo:'',
				yuedu: 0,
				dingyue: 0,
				shoucang: 0,
				isChangeUsername: false,
				isChangePhone: false,
				isChangePassword: false,
				isYQJT:false,
				isQXJT:false,
				isBDJT:false,
				newUsername: '',
				newPhone: '',
				oldphonecode:'',
				oldphonecountdown:0,
				oldphonetimer:'',
				newphonecode:'',
				newphonecountdown:0,
				newphonetimer:'',
				oldPassword:'',
				newPassword: '',
				newPasswordConfirm: '',
				pisweekalert:'',
				pwdcode:'',
				pwdcountdown:0,
				pwdtimer:'',
			}
		},
		props: [
			'userinfo',
			'isdetailopen'
		],
		mounted: function() {
			this.getuserinfofnc();
			this.getAllCount();
			if(this.$cookies.get('pwdcountdown')&&parseInt(this.$cookies.get('pwdcountdown'))){
				this.setCountdown(parseInt(this.$cookies.get('pwdcountdown')));
			}
			if(this.$cookies.get('oldphonecountdown')&&parseInt(this.$cookies.get('oldphonecountdown'))){
				this.setOldPhoneCountdown(parseInt(this.$cookies.get('oldphonecountdown')));
			}
			if(this.$cookies.get('newphonecountdown')&&parseInt(this.$cookies.get('newphonecountdown'))){
				this.setNewPhoneCountdown(parseInt(this.$cookies.get('newphonecountdown')));
			}
		},
		methods: {
			showbangding:function(){
				this.$emit('showbangding',this.userinfo);
			},
			showquxiao:function(){
				this.$emit('showquxiao',this.userinfo);
			},
			showyanqi:function(){
				this.$emit('showyanqi',this.userinfo);
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			getuserinfofnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'UserInfo/getUserInfo',
						responseType: 'json',
						params: {

						},
					})
					.then(function(response) {
						_this.completeUserinfo = response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getAllCount: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/GetUserReadCount',
						responseType: 'json',
						params: {
							userid: this.userinfo ? this.userinfo.userAccountID : '',
						},
					})
					.then(function(response) {
						_this.yuedu = response.data.data.data.sReadCount;
						_this.dingyue = response.data.data.data.sOrdersCount;
						_this.shoucang = response.data.data.data.sFavoritesCount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			checkisPhone:function(s){
				var regexp = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				return regexp.test(s);
			},
			changeUsername:function(){
				if(this.newUsername){
					
					//230426添加规则，用户名不能为纯数字
					var re=/^[0-9]*$/;
					if(re.test(this.newUsername)){
						this.$message({
							message: '用户名不能为纯数字',
							type: 'warning'
						});
						return false
					}
					
					let _this = this;
					_this.loadingMask = true;
					this.$http({
							method: 'post',
							url: 'UserInfo/ModifyAccount',
							responseType: 'json',
							params: {
								Account:this.newUsername
							},
						})
						.then(function(response) {
							if(response.data.code==20000){
								_this.$message({
									message: response.data.data.msg,
									type: 'success'
								});
								_this.isChangeUsername=false;
								_this.getuserinfofnc();
							}
							else{
								_this.$message({
									message: response.data.data.msg,
									type: 'warning'
								});
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.loadingMask = false;
							console.log(error);
						});
				}
				else{
					this.$message({
						message: '请填写新用户名',
						type: 'warning'
					});
				}
			},
			setOldPhoneCountdown:function(num){
				let _this = this;
				_this.oldphonecountdown=num;
				clearInterval(_this.oldphonetimer);
				_this.oldphonetimer=setInterval(function(){
					// debugger;
					if(_this.oldphonecountdown>1){
						_this.oldphonecountdown--;
						_this.$cookies.set('oldphonecountdown',_this.oldphonecountdown,_this.oldphonecountdown);
					}
					else{
						_this.oldphonecountdown=0;
						clearInterval(_this.oldphonetimer);
						_this.$cookies.remove('oldphonecountdown');
					}
				},1000);
			},
			setNewPhoneCountdown:function(num){
				let _this = this;
				_this.newphonecountdown=num;
				clearInterval(_this.newphonetimer);
				_this.newphonetimer=setInterval(function(){
					// debugger;
					if(_this.newphonecountdown>1){
						_this.newphonecountdown--;
						_this.$cookies.set('newphonecountdown',_this.newphonecountdown,_this.newphonecountdown);
					}
					else{
						_this.newphonecountdown=0;
						clearInterval(_this.newphonetimer);
						_this.$cookies.remove('newphonecountdown');
					}
				},1000);
			},
			sendOldPhoneCode:function(){
				let _this = this;
				if(_this.oldphonecountdown>0){
					_this.$message({
						message: '不可频繁发送验证码',
						type: 'warning'
					});
					return false;
				}
				if(_this.completeUserinfo.tel){
					_this.oldphonecountdown=60;
					_this.loadingMask = true;
					this.$http({
							method: 'post',
							url: 'UserInfo/getChangPhoneCodeInfo',
							responseType: 'json',
							params: {
								
							},
						})
						.then(function(response) {
							
							if(response.data.code==20000){
								_this.$message({
									message: response.data.data.msg,
									type: 'success'
								});
								_this.setOldPhoneCountdown(60);
							}
							else{
								_this.$message({
									message: '发送失败',
									type: 'warning'
								});
								_this.oldphonecountdown=0;
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.oldphonecountdown=0;
							_this.loadingMask = false;
							console.log(error);
						});
				}
				else{
					this.$message({
						message: '未找到绑定手机号',
						type: 'warning'
					});
				}
			},
			sendNewPhoneCode:function(){
				let _this = this;
				if(_this.newphonecountdown>0){
					_this.$message({
						message: '不可频繁发送验证码',
						type: 'warning'
					});
					return false;
				}
				if(_this.newPhone&&_this.checkisPhone(_this.newPhone)){
					_this.newphonecountdown=60;
					_this.loadingMask = true;
					this.$http({
							method: 'post',
							url: 'UserInfo/getChangPhoneCodeInfo',
							responseType: 'json',
							params: {
								newPhone:this.newPhone
							},
						})
						.then(function(response) {
							if(response.data.code==20000){
								_this.$message({
									message: response.data.data.msg,
									type: 'success'
								});
								_this.setNewPhoneCountdown(60);
							}
							else{
								_this.$message({
									message: '发送失败',
									type: 'warning'
								});
								_this.newphonecountdown=0;
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.newphonecountdown=0;
							_this.loadingMask = false;
							console.log(error);
						});
				}
				else{
					this.$message({
						message: '请填写正确的手机号',
						type: 'warning'
					});
				}
			},
			changePhone:function(){
				if(this.newPhone&&this.checkisPhone(this.newPhone)&&this.oldphonecode&&this.newphonecode){
					let _this = this;
					_this.loadingMask = true;
					this.$http({
							method: 'post',
							url: 'UserInfo/getChangPHCodeInfo',
							responseType: 'json',
							params: {
								oldPhone:this.completeUserinfo.tel,
								newPhone:this.newPhone,
								oldPhoneCode:this.oldphonecode,
								newPhoneCode:this.newphonecode,
							},
						})
						.then(function(response) {
							if(response.data.code==20000){
								//验证通过后直接修改
								_this.$http({
										method: 'post',
										url: 'UserInfo/editMobile',
										responseType: 'json',
										params: {
											Mobile:_this.completeUserinfo.tel,
											NewMobile:_this.newPhone,
										},
									})
									.then(function(response) {
										if(response.data.code==20000){
											_this.$message({
												message: response.data.data.msg,
												type: 'success'
											});
											_this.isChangePhone=false;
											_this.getuserinfofnc();
										}
										else{
											_this.$message({
												message: response.data.data.msg,
												type: 'warning'
											});
										}
										_this.loadingMask = false;
									})
									.catch(function(error) {
										_this.loadingMask = false;
										console.log(error);
									});
							}
							else{
								_this.$message({
									message: response.data.data.msg,
									type: 'warning'
								});
								_this.loadingMask = false;
							}
						})
						.catch(function(error) {
							_this.loadingMask = false;
							console.log(error);
						});
				}
				else{
					this.$message({
						message: '请填写正确的手机号及验证码',
						type: 'warning'
					});
				}
			},
			setCountdown:function(num){
				let _this = this;
				_this.pwdcountdown=num;
				clearInterval(_this.pwdtimer);
				_this.pwdtimer=setInterval(function(){
					// debugger;
					if(_this.pwdcountdown>1){
						_this.pwdcountdown--;
						_this.$cookies.set('pwdcountdown',_this.pwdcountdown,_this.pwdcountdown);
					}
					else{
						_this.pwdcountdown=0;
						clearInterval(_this.pwdtimer);
						_this.$cookies.remove('pwdcountdown');
					}
				},1000);
			},
			sendPWDCode:function(){
				let _this = this;
				if(_this.pwdcountdown>0){
					_this.$message({
						message: '不可频繁发送验证码',
						type: 'warning'
					});
					return false;
				}
				if(_this.completeUserinfo.tel){
					_this.pwdcountdown=60;
					_this.loadingMask = true;
					this.$http({
							method: 'post',
							url: 'UserInfo/getChangPWDCodeInfo',
							responseType: 'json',
							params: {
								
							},
						})
						.then(function(response) {
							if(response.data.code==20000){
								_this.$message({
									message: response.data.data.msg,
									type: 'success'
								});
								_this.setCountdown(60);
							}
							else{
								_this.$message({
									message: '发送失败',
									type: 'warning'
								});
								_this.pwdcountdown=0;
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.pwdcountdown=0;
							_this.loadingMask = false;
							console.log(error);
						});
				}
				else{
					this.$message({
						message: '未找到绑定手机号',
						type: 'warning'
					});
				}
			},
			checkPasswordError:function(){
				// debugger;
				var pisweek=true;
				this.pisweekalert='';
				var strongRegex = new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
				var mediumRegex = new RegExp("^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g");
				var enoughRegex = new RegExp("(?=.{6,}).*", "g");
				if (isNameInPwd(this.completeUserinfo.username, this.newPassword) ) {
						pisweek = true;
						this.pisweekalert='密码中包含用户名，请重新设置!';
				} else if (isInweek(this.newPassword)) {
						pisweek = true;
						this.pisweekalert='密码强度弱!';
				} else if (false == enoughRegex.test(this.newPassword)) {
						pisweek = true;
						this.pisweekalert='字符太短!';
				} else if (strongRegex.test(this.newPassword)) {
						pisweek = false;
						// this.pisweekalert='密码强度强!';
				} else if (mediumRegex.test(this.newPassword)) {
						pisweek = false;
						// this.pisweekalert='密码强度中!';
				} else {
						pisweek = true;
						this.pisweekalert='密码强度弱!';
				}
				return pisweek;
			},
			changePassword:function(){
				if (this.newPassword.trim().length == 0) {
					this.$message({
						message: '请输入验证码！',
						type: 'warning'
					});
						return false;
				}
				if (this.newPassword.length < 6) {
					this.$message({
						message: '密码长度小于6位，请输入大于6位长度的密码！',
						type: 'warning'
					});
						return false;
				}
				if ( this.newPassword.length == 0 || this.newPasswordConfirm.length == 0) {
					this.$message({
						message: '请输入密码信息！',
						type: 'warning'
					});
						return false;
				}
				if (this.checkPasswordError() == true) {
					this.$message({
						message: '密码强度太弱，请设置更复杂密码，如数字+字母+特殊字符，而且长度大于6位！',
						type: 'warning'
					});
						return false;
				}
				if (this.newPassword != this.newPasswordConfirm) {
					this.$message({
						message: '新密码两次输入不一致！',
						type: 'warning'
					});
						return false;
				}
				
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/editPwd',
						responseType: 'json',
						params: {
							NewPassword:md5(this.newPassword),
							PwdCode:this.pwdcode
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: response.data.data.msg,
								type: 'success'
							});
							_this.newPassword='';
							_this.newPasswordConfirm='';
							_this.pwdcode='';
							_this.isChangePassword=false;
						}
						else{
							_this.$message({
								message: response.data.data.msg,
								type: 'warning'
							});
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
		},
	}
</script>

<style>
</style>
